<template>
  <div>
    <transition name="fademinimap_open">
      <div v-show="!isDisplayed">
        <button
          class="showbutton"
          @click="togglemap"
        >
          <b-icon
            class
            pack="fas"
            icon="external-link-alt"
            size="is-small"
          ></b-icon>
        </button>
      </div>
    </transition>

    <transition name="fademinimap_close">
      <div
        v-touch.stop.prevent="()=>{}"
        @click.stop="()=>{}"
        class="minimap"
        id="minimap"
        v-show="isDisplayed"
      >
        <button
          class="closebutton noTouch"
          v-touch="togglemap"
        >
          <b-icon
            class="noTouch"
            pack="far"
            icon="times-circle"
            size="is-small"
          ></b-icon>
        </button>
        <svg id="svgMiniBoard">
          <circle
            :cx="5 + post.coord_x"
            :cy="5 + post.coord_y"
            r="4"
            stroke-width="0"
            stroke="rgba(0,0,0,0)"
            :style="'fill:'+post.couleur+';'"
            v-for="post in filteredPosts"
            :key="'minipost'+post.id"
          />
          <foreignObject
            v-for="(folder,key) in this.filteredFolders"
            :transform="`translate(${folder.coord_x-5} ${folder.coord_y-5})`"
            :key="key+'folder'"
            width="15"
            height="20"
          >
            <i class="fas folder fa-folder"></i>
          </foreignObject>
          <rect
            ref="rectMiniRed"
            class="rectminired"
            :x="mini_x"
            :y="mini_y"
            :width="mini_w"
            :height="mini_h"
            stroke-width="4"
            stroke="#CD0000"
            fill="rgba(0,0,0,0.25)"
          />
        </svg>
      </div>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EventBus from '../../EventBus'
import interact from 'interactjs'

const { mapState } = createNamespacedHelpers('board')
export default {
  name: 'minimap',
  data: function () {
    return {
      mini_x: 0,
      mini_y: 0,
      mini_w: 0,
      mini_h: 0,
      el: null,
      move: false,
      isDisplayed: true
    }
  },
  computed: {
    filteredFolders () {
      let folderList = JSON.parse(JSON.stringify(this.folders.filter(folder => folder.sheet_id === this.currentSheet)))
      folderList.forEach(folder => {
        folder.coord_x = (folder.coord_x * 300) / 3840
        folder.coord_y = (folder.coord_y * 169) / 2160
      })
      return folderList
    },
    filteredPosts () {
      let postList = []

      if (this.postlist.length !== 0) {
        this.postlist.forEach(element => {
          var newobj = JSON.parse(JSON.stringify(element))

          if (
            newobj.etat === 'publie' &&
            newobj.sheet_id === this.currentSheet &&
            newobj.folder_id === null
          ) {
            newobj.coord_x = (newobj.coord_x * 300) / 3840
            newobj.coord_y = (newobj.coord_y * 169) / 2160
            postList.push(newobj)
          }
        })
      }
      return postList
    },
    ...mapState({
      postlist: 'currentBoardPost',
      current: 'current',
      folders: 'folders',
      currentSheet: 'currentSheet',
      isLoading: 'isLoading'
    })
  },
  watch: {
    currentSheet: {
      handler: function (val) {
        this.background(val)
      }
    },
    isLoading: {
      handler: function () {
        this.background(this.currentSheet)
      }
    }
  },
  mounted () {
    this.el = document.getElementsByClassName('boardmeeting')[0]
    let myDraggable = this.$refs.rectMiniRed
    this.initInteract(myDraggable)

    interact(document.querySelector('#minimap')).pointerEvents({
      ignoreFrom: '.noTouch'
    }).on('tap', e => {
      console.log(e)

      if (e.layerX + this.mini_w < 300) {
        this.mini_x = e.layerX
      } else {
        this.mini_x = 300 - this.mini_w
      }

      if (e.layerY + this.mini_h < 169) {
        this.mini_y = e.layerY
      } else {
        this.mini_y = 169 - this.mini_h
      }

      var X = ((e.layerX * 3840) / 300) - (this.el.offsetWidth / 2)
      var Y = ((e.layerY * 2160) / 169) - (this.el.offsetHeight / 2)

      this.el.scrollTo(X, Y)
    })

    // this.minimapElement = document.getElementById('minimap')
    this.el.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleScroll)
    this.handleScroll()
  },
  created () {
    document.addEventListener('touchmove', (e) => { e.preventDefault() })
    EventBus.$on('UPLOAD_SHEET', idSheet => {
      this.background(idSheet)
    })
  },
  methods: {
    initInteract (selector) {
      interact(selector).draggable({
        // enable inertial throwing
        inertia: false,
        // ignoreFrom: '#postsContainer',
        // keep the element within the area of it's parent
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: 'parent',
            endOnly: true
          })
        ],
        restrictRect: {
          restriction: 'parent',
          endOnly: true
        },
        // enable autoScroll
        autoScroll: false,
        // autoScroll: {
        //   container: document.querySelector('#boardMeeting'),
        //   margin: 50,
        //   distance: 5,
        //   interval: 10,
        //   speed: 500
        // },

        // call this function on every dragmove event
        onmove: this.moveRect,
        // call this function on every dragend event
        onend: this.stopMoving
      })
    },
    moveRect (e) {
      e.preventDefault()
      let dif = e.delta

      var posX =
        e.clientX -
        document.getElementById('svgMiniBoard').getBoundingClientRect().left -
        dif.x
      var posY =
        e.clientY -
        document.getElementById('svgMiniBoard').getBoundingClientRect().top -
        dif.y

      if (posX < 0) {
        posX = 0
      }

      if (posY < 0) {
        posY = 0
      }

      if (posX + this.mini_w < 300) {
        this.mini_x = posX - this.mini_w / 2
        this.mini_x = posX - this.mini_w
      } else {
        this.mini_x = 300 - this.mini_w - this.mini_w / 2
        this.mini_x = 300 - this.mini_w
      }

      if (posY + this.mini_h < 169) {
        this.mini_y = posY - this.mini_h / 2
        this.mini_y = posY - this.mini_h
      } else {
        this.mini_y = 169 - this.mini_h - this.mini_h / 2
        this.mini_y = 169 - this.mini_h
      }
      this.mini_x = this.mini_x < 0 ? 0 : this.mini_x
      this.mini_y = this.mini_y < 0 ? 0 : this.mini_y

      var X = ((posX * 3840) / 300) - (this.el.offsetWidth / 2)
      var Y = ((posY * 2160) / 169) - (this.el.offsetHeight / 2)

      this.el.scrollTo(X, Y)
    },
    stopMoving (e) {
    },
    logEvent (e) {
      // console.log(e.currentTarget.closest('svg'))
    },
    background (idSheet) {
      // permet de savoir quelle feuille est en cours
      let sheet_en_cours = this.current.sheets.filter(
        feuille => feuille.id === idSheet
      )
      // bg de la board
      if (this.current.template !== null && sheet_en_cours[0].url === null) {
        document
          .getElementById('svgMiniBoard')
          .setAttribute(
            'style',
            "background:url('" +
            process.env.URL_MEDIA +
            this.current.template.url +
            "')no-repeat 0% 0%;background-size:100%;"
          )
        // bg de la feuille
      } else if (sheet_en_cours[0].url !== null) {
        document
          .getElementById('svgMiniBoard')
          .setAttribute(
            'style',
            "background:url('" +
            process.env.URL_MEDIA +
            sheet_en_cours[0].url +
            "') no-repeat 0% 0%;background-size:100%;"
          )
        // bg by default
      } else {
        document
          .getElementById('svgMiniBoard')
          .setAttribute(
            'style',
            'background: url("/static/quadrillage.png") no-repeat 0% 0%;background-size:100%;'
          )
      }
    },
    togglemap () {
      this.isDisplayed = !this.isDisplayed
    },
    handleScroll () {
      if (!this.move) {
        this.mini_x = (this.el.scrollLeft * 300) / 3840
        this.mini_y = (this.el.scrollTop * 169) / 2160

        this.mini_w = (this.el.offsetWidth * 300) / 3840 - 6
        this.mini_h = (this.el.offsetHeight * 169) / 2160 - 6
      }
    }
  }
}
</script>

<style scoped>
.closebutton {
  right: 0;
  position: absolute;
  background-color: black;
  border: 0;
  color: white;
  cursor: pointer;
  padding: 0px 0px 2px 3px;
  border-radius: 0px 0px 0px 5px;
}
.showbutton {
  position: fixed;
  bottom: 0;
  left: 0;
  margin-bottom: 0px;
  padding: 5px;
  margin-bottom: 20px;
  background-color: black;
  border: 0;
  color: white;
  cursor: pointer;
  z-index: 100;
}

#svgMiniBoard {
  width: 100%;
  height: 100%;
}
.rectminired {
  cursor: move;
  touch-action: none;
}

.minimap {
  background-color: white;
  opacity: 1;
  border: 3px solid black;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 300px;
  height: 169px;
  margin-bottom: 25px;
  z-index: 8;
}

.fademinimap_close-enter-active,
.fademinimap_close-leave-active {
  transition: opacity 0.5s, width 1s, height 1s;
}
.fademinimap_close-enter, .fademinimap_close-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  width: 0px;
  height: 0px;
}

.fademinimap_open-enter-active,
.fademinimap_open-leave-active {
  transition: opacity 0.5s;
}
.fademinimap_open-enter, .fademinimap_open-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.folder {
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/minimap.vue